import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Layout from "../layouts/LayoutDefault.jsx";
import MakeGetRequest from "../components/utils/MakeGetRequest";
import MainContainer from "../components/MainContainer.jsx";
import ContentContainer from "../components/ContentContainer.jsx";
import OrganizerEventsList from "../components/org_page/OrganizerEventsList.jsx";
import CommercialBanner from "../components/CommercialBanner.jsx";

const OrgPage = () => {
  const { slug } = useParams();
  const token = useSelector((state) => state.token);

  const { data: orgData } = MakeGetRequest({
    route: `get_organizer_profile?slug=${slug}`,
    errorCodeRedirect: 404,
  });

  const organizer =
    orgData?.organizer || orgData?.current_organizer || orgData?.org || null;

  const name = organizer?.name || "Arrangör";
  const description =
    organizer?.description || "Arrangörssida med information och evenemang.";
  const profileImage = organizer?.image_profile || "";

  const allEvents = orgData?.events || [];
  const upcomingEvents = orgData?.upcoming_events;
  const previousEvents = orgData?.previous_events;

  return (
    <Layout
      title={name}
      description={`${name}. ${description}`.substring(0, 155)}
    >
      {orgData ? (
        <MainContainer>
          <ContentContainer>
            <div className="grid md:grid-cols-3 gap-8 items-start">
              <div className="md:col-span-1">
                {profileImage ? (
                  <img
                    src={profileImage}
                    alt={`Profilbild för ${name}`}
                    className="w-full max-w-xs rounded-2xl border border-white/10 object-cover shadow-lg"
                  />
                ) : (
                  <div className="w-full max-w-xs h-52 rounded-2xl border border-white/10 bg-[#131313] flex items-center justify-center shadow-lg">
                    <p className="text-xs font-bold text-stone-500 uppercase tracking-widest">Ingen profilbild</p>
                  </div>
                )}
              </div>
              <div className="md:col-span-2 space-y-4">
                <div>
                  <h1 className="text-4xl sm:text-5xl font-black text-white uppercase tracking-wider">{name}</h1>
                  <p className="text-[#0047ff] text-xs font-black tracking-widest uppercase mt-2">
                    Arrangör
                  </p>
                </div>
                <div className="text-stone-300 leading-relaxed text-sm sm:text-base whitespace-pre-wrap bg-[#131313] border border-white/10 rounded-2xl p-6 shadow-md">
                  {description}
                </div>
                <div className="pt-2 flex flex-wrap gap-3">
                  {token && organizer?.official_mail && (
                    <a
                      href={`mailto:${organizer.official_mail}`}
                      className="inline-flex items-center text-xs font-bold text-stone-200 hover:text-white hover:border-[#0047ff] hover:bg-[#0047ff]/10 transition-all duration-300 bg-[#131313] border border-white/10 rounded-full px-4 py-2.5 shadow-sm"
                    >
                      {organizer.official_mail}
                    </a>
                  )}
                  {organizer?.official_homepage && (
                    <a
                      href={organizer.official_homepage}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center text-xs font-bold text-stone-200 hover:text-white hover:border-[#0047ff] hover:bg-[#0047ff]/10 transition-all duration-300 bg-[#131313] border border-white/10 rounded-full px-4 py-2.5 shadow-sm"
                    >
                      Hemsida
                    </a>
                  )}
                </div>
              </div>
            </div>
          </ContentContainer>

          <ContentContainer>
            <OrganizerEventsList
              events={allEvents}
              upcomingEvents={upcomingEvents}
              previousEvents={previousEvents}
            />
          </ContentContainer>

          <CommercialBanner />
        </MainContainer>
      ) : (
        <MainContainer>
          <ContentContainer>
            <div className="text-center py-10">
              <h4 className="text-xl">Laddar arrangör...</h4>
            </div>
          </ContentContainer>
        </MainContainer>
      )}
    </Layout>
  );
};

export default OrgPage;
